import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-fund-card',
  templateUrl: './fund-card.component.html',
  styleUrls: ['./fund-card.component.scss']
})
export class FundCardComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  @Input()
  // renderFundObject: Array<Object> = []
  renderFundObject: any;

  checkMonth: Array<Object> = [
    {
      number: 1,
      name: 'ม.ค.'
    },
    {
      number: 2,
      name: 'ก.พ.'
    },
    {
      number: 3,
      name: 'มี.ค.'
    },
    {
      number: 4,
      name: 'เม.ย.'
    },
    {
      number: 5,
      name: 'พ.ค.'
    },
    {
      number: 6,
      name: 'มิ.ย.'
    },
    {
      number: 7,
      name: 'ก.ค.'
    },
    {
      number: 8,
      name: 'ส.ค.'
    },
    {
      number: 9,
      name: 'ก.ย.'
    },
    {
      number: 10,
      name: 'ต.ค.'
    },
    {
      number: 11,
      name: 'พ.ย.'
    },
    {
      number: 12,
      name: 'ธ.ค.'
    }
  ];

  caretStatus = ''

  flag: any

  // fav: boolean

  constructor() { }

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")
    // this.fav = false
  }

  isPositive(value) {
    if (Math.sign(value) == 1) {
      this.caretStatus = 'up'
      return true
    } else if (Math.sign(value) == -1 || Math.sign(value) == 0) {
      this.caretStatus = 'down'
      return false
    }
  }

  showOnlyValue(value) {
    return Math.abs(value)
  }

  setNumberFormat(value) {
    return parseFloat(value).toFixed(2);
  }

  changeFormatDate(date) {
    if (date != "") {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day + ' ' + monthTh['name'] + ' ' + year;
    }
    else {
      return "";
    }

  }

  fixFloatDigit(value) {
    return parseFloat(value).toFixed(4);
  }
}
